<template>
  <div class="login-bg">
    <div class="content">
      <div class="intro">
        <!-- <div class="intro-title">双安预防体系智能系统</div>
        <div class="intro-tip">安全风险辨识管控与隐患排查治理</div>
        <div class="intro-tip">双重预防云平台</div> -->
      </div>
      <div class="login-form">
        <div class="title">修改密码</div>
        <div class="name">
          <i class="phone-icon"></i>
          <input
            type="text"
            v-model.trim="formData.phone"
            placeholder="请输入手机号"
          />
        </div>
        <div class="password">
          <i class="verification-icon"></i>
          <input placeholder="请输入验证码" v-model.trim="formData.code" />
          <button
            ref="verificationRef"
            type="button"
            class="click-button"
            :disabled="verificationState"
            @click="getVerificationCode"
          >
            {{ verificationText }}
          </button>
        </div>
        <div style="height:30px;color:red;margin-left:30.5px;line-height:30px">
          {{ phoneMessageText }}
        </div>
        <div class="newPassword" style="margin-top:2px">
          <i class="password-icon"></i>
          <input
            type="text"
            v-model.trim="formData.newPassword"
            placeholder="请输入新的密码"
          />
        </div>
        <div class="button" style="margin-top:40px">
          <el-button type="primary" @click="confirmEdit()">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "forgetPassword",
  data() {
    return {
      formData: {
        phone: "",
        code: "",
        newPassword: ""
      },
      verificationState: false,
      verificationText: "获取验证码",
      phoneMessageText: ""
    };
  },
  methods: {
    getVerificationCode() {
      if (this.formData.phone == "") {
        this.$message.warning("请输入手机号");
      } else {
        let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!myreg.test(this.formData.phone)) {
          this.formData.phone = "";
          this.$message.warning("请输入正确手机号");
        } else {
          this.getVerificationCodeData();
        }
      }
    },
    async getVerificationCodeData() {
      let req = { phone: this.formData.phone, type: 2 };
      let res = await this.$Http.getVerifyCode(req, true);
      if (res.code == 200) {
          this.phoneMessageText = ''
        this.time = 60;
        this.timer();
      } else {
        this.phoneMessageText = res.messsage || "";
      }
    },
    //发送手机验证码倒计时
    timer() {
      if (this.time > 0) {
        this.verificationState = true;
        this.time--;
        this.verificationText = this.time + "秒";
        setTimeout(this.timer, 1000);
        this.$refs.verificationRef.className = "un-click-button";
      } else {
        this.verificationText = "发送验证码";
        this.verificationState = false;
        this.$refs.verificationRef.className = "click-button";
      }
    },
    async confirmEdit() {
      let res = await this.$Http.forgotPassword(this.formData, true);
      if (res.code == 200) {
        this.$message({
          message: "密码修改成功",
          type: "success"
        });
        this.$Common.pageJump('/login',0)
      } else {
        this.$message({
          message: "密码修改失败",
          type: "error"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}

.login-bg {
  width: 100vw;
  height: 100vh;
  background: url("~@/assets/img/login/login-bg.gif") center top no-repeat;
  background-size: cover;
  position: relative;
  input:-webkit-autofill {
    color: #ffffff;
    background: transparent !important;
    box-shadow: inset 0px 1px 9px 0px #4955ac;
    border: none;
  }
}

.intro {
  width: 300px;
  position: absolute;
  top: 14.8%;
  .intro-title {
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    letter-spacing: 2px;
    position: relative;
    // &:after {
    //   display: block;
    //   content: "";
    //   width: 140px;
    //   height: 2px;
    //   background: rgba(255, 255, 255, 0.9);
    //   position: absolute;
    //   left: 5px;
    //   top: 38px;
    // }
  }

  .intro-tip {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 550;
    color: rgb(69, 171, 189);
    line-height: 29px;
    letter-spacing: 2px;
  }
}

.login-form {
  width: 380px;
  height: 410px;
  position: absolute;
  top: 24.2%;
  // top: 195px;
  /* right: 348px; */
  box-shadow: inset 0px 1px 38px 0px rgba(65, 77, 161, 0.5);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

@media screen and (min-width: 1684px) {
  .login-form {
    right: 348px;
  }
  .intro {
    top: 14.6%;
    left: 310px;
    .intro-title {
      font-size: 22px;
      margin-bottom: 10px;
      color:rgb(84, 210, 233);
    }

    .intro-tip {
      font-size: 18px;
      line-height: 29px;
      letter-spacing: 2px;
    }
  }
}

@media screen and (max-width: 1683px) {
  .login-form {
    right: 48px;
  }
  .intro {
    position: absolute;
    top: 12.4%;
    left: 100px;
    .intro-title {
      font-size: 20px;
      margin-bottom: 10px;
    }

    .intro-tip {
      font-size: 16px;
      line-height: 26px;
      letter-spacing: 2px;
    }
  }
}

.title {
  padding-top: 24px;
  text-align: center;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 33px;
}

.name,
.password,
.newPassword {
  margin: 32px auto 0 auto;
  width: 319px;
  height: 50px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.name-icon {
  display: inline-block;
  width: 20px;
  height: 23px;
  background: url("~@/assets/img/login/login-name-icon.png") center center
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 14px;
  top: 14px;
}
.password-icon {
  display: inline-block;
  width: 20px;
  height: 23px;
  background: url("~@/assets/img/login/login-password-icon.png") center center
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 14px;
  top: 14px;
}
.phone-icon {
  display: inline-block;
  width: 20px;
  height: 23px;
  background: url("~@/assets/img/login/login-phone-icon.png") center center
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 14px;
  top: 14px;
}
.verification-icon {
  display: inline-block;
  width: 20px;
  height: 23px;
  background: url("~@/assets/img/login/login-verification-icon.png") center
    center no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 14px;
  top: 14px;
}
.name input,
.password input,
.newPassword input {
  width: 100%;
  height: 100%;
  box-shadow: inset 0px 1px 9px 0px #4955ac;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.42);
  background: transparent;
  padding-left: 52px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  &:-internal-autofill-selected {
    background: transparent !important;
    box-shadow: inset 0px 1px 9px 0px #4955ac;
  }
}
.click-button {
  position: absolute;
  height: 35px;
  width: 100px;
  right: 10px;
  color: #ffffff;
  background: url("~@/assets/img/login/login-button-bg.png") center center
    no-repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  border: none; // 去掉边框
  outline: none; // 去掉点击按钮后的边框
  transition: transform 0.3s;
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
  }
}
.un-click-button {
  position: absolute;
  height: 35px;
  width: 100px;
  right: 10px;
  color: #000;
  opacity: 0.8;
  font-weight: 500;
  background: url("~@/assets/img/login/count-down-bg.png") center center
    no-repeat;
  background-size: 100% 100%;
  border: none; // 去掉边框
  outline: none; // 去掉点击按钮后的边框
  cursor: pointer;
  border-radius: 4px;
}
.password-button {
  position: absolute;
  height: 35px;
  width: 100px;
  right: 10px;
  color: #b3bdff;
  background-color: transparent;
  border: none; // 去掉边框
  outline: none; // 去掉点击按钮后的边框
  border-radius: 4px;
  transition: transform 0.3s;
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
  }
}
input:focus {
  outline: none;
}

.button {
  text-align: center;
}

.el-button {
  width: 157px;
  height: 45px;
  background: rgba(8, 161, 253, 1);
  border-radius: 8px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  border: 1px solid rgba(220, 223, 230, 0.2);
}
.login-select {
  margin-top: 20px;
  width: 100%;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  opacity: 0.8;
  .login-select-left {
    width: 50%;
    text-align: center;
    transition: transform 0.3s;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
    }
  }
  .login-select-right {
    width: 50%;
    text-align: center;
    transition: transform 0.3s;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
    }
  }
}
.QR {
  height: 249px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
input::-webkit-input-placeholder { 
/* WebKit browsers */ 
color: rgba(134, 218, 252, 0.6); 
} 
input:-moz-placeholder { 
/* Mozilla Firefox 4 to 18 */ 
color: rgba(134, 218, 252, 0.6); 
} 
input::-moz-placeholder { 
/* Mozilla Firefox 19+ */ 
color: rgba(134, 218, 252, 0.6); 
} 
input:-ms-input-placeholder { 
/* Internet Explorer 10+ */ 
color: rgba(134, 218, 252, 0.6); 
}
</style>
